import * as React from "react";
import { ActivationCode } from "./ActivationCode";
import { FormattedDateTime } from "./FormattedDateTime";
import { NationalId } from "./NationalId";
import i18next from 'i18next';
export var IssueResultActivationCode = function (props) {
    return props.activationCode && props.activationCodeExpiresAt ? (React.createElement("div", { style: { border: "1px solid gray", padding: 20, borderRadius: 2 } },
        React.createElement("table", { style: { width: "100%", height: 120 } },
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", { style: { width: "50%", verticalAlign: "top" } },
                        React.createElement("div", { style: {
                                fontSize: 20,
                                fontWeight: "bold",
                                fontFamily: "Oswald, Arial",
                            } },
                            props.user.firstName,
                            " ",
                            props.user.lastName),
                        React.createElement("div", null,
                            props.user.nationalId ? (React.createElement(NationalId, { nationalId: props.user.nationalId, country: props.user.organization.country })) : null,
                            props.user.nationalId && props.user.tfNumber ? ", " : null,
                            props.user.tfNumber)),
                    React.createElement("td", { style: { width: "50%", textAlign: "right", verticalAlign: "top" } },
                        React.createElement("div", null, props.user.emails.length > 0
                            ? props.user.emails[0].value
                            : null))),
                React.createElement("tr", null,
                    React.createElement("td", { style: { width: "50%", verticalAlign: "bottom" } },
                        i18next.t("cc.issue.search.activation.code.activationCode"),
                        " ",
                        React.createElement("strong", null,
                            React.createElement(ActivationCode, { activationCode: props.activationCode })),
                        React.createElement("br", null),
                        i18next.t("cc.issue.search.activation.code.valid"),
                        " ",
                        React.createElement(FormattedDateTime, { date: new Date(props.activationCodeExpiresAt) })),
                    React.createElement("td", { style: {
                            width: "50%",
                            textAlign: "right",
                            verticalAlign: "bottom",
                        } },
                        i18next.t("cc.issue.search.activation.code.activateAccountOn"),
                        React.createElement("br", null),
                        React.createElement("a", { target: "_blank", href: props.skolidUrl + i18next.t("cc.issue.search.activation.code.activateCode") },
                            React.createElement("strong", null, props.skolidUrl + i18next.t("cc.issue.search.activation.code.activateCode"))))))))) : null;
};
//# sourceMappingURL=IssueResultActivationCode.js.map